module.exports = __webpack_public_path__ + "img/2-2.4b32e59e.png";